 export default {
     props: {
         isEditing: {
             type: Boolean,
             default: false
         },
         name: {
             type: String,
             default: ''
         },
         lng: {
             default () {
                 return '105.2141942496418';
             }
         },
         lat: {
             default () {
                 return '38.32113002834947';
             }
         },
         zoom: {
             type: Number,
             default () {
                 return 5;
             }
         },
         zoomMin: {
             type: Number,
             default () {
                 return 5;
             }
         },
         zoomMax: {
             type: Number,
             default () {
                 return 19;
             }
         },
         //工具条
         zoomTool: {
             type: Boolean,
             default: true
         },
         //鼠标放大
         mouseZoom: {
             type: Boolean,
             default: true
         },
         //地图拖拽
         drag: {
             type: Boolean,
             default: true
         },
         //地图样式
         mapStyle: {
             default: null
         },
         isLabelText: {
             type: Boolean,
             default: true
         },
         api: {
             type: String,
             default: `../default-data/polygon-count-data.json`,
         },
         scale: {
             default () {
                 return 1;
             }
         },
         showMap: {
             type: Boolean,
             default: true
         },
         tooltip:{
            type: String,
            default: "{name}+'：'+{count}"
         },
         isTooltip: {
             type: Boolean,
             default: true
         },

         isLegend: {
             type: Boolean,
             default: true
         },
         legendTitle: {
             type: String,
             default: '标题'
         },
         isAutoColor: {
             type: Boolean,
             default: true
         },
         // borderColor: {
         //     type: String,
         //     default: null
         // },
         // borderWidth: {
         //     type: Number,
         //     default: 1
         // },
         isLabel: {
             type: Boolean,
             default: true
         },
         opacity: {
             type: Number,
             default: 0.7
         }
         // labelColor: {
         //     type: String,
         //     default: "#fff"
         // },
         // mouseOverLabelColor: {
         //     type: String,
         //     default: "rgba(255,255,255,1)"
         // },
         // backgroundColor: {
         //     type: String,
         //     default: "rgba(0, 133, 235, 0.6)"
         // },
         // mouseOverBackgroundColor: {
         //     type: String,
         //     default: ""
         // },
         // selectedBackgroundColor: {
         //     type: String,
         //     default: "rgba(184,0,0,1)"
         // },
         // selectedBorderColor: {
         //     type: String,
         //     default: "rgba(255,255,255,1)"
         // },
         // selectedLableColor: {
         //     type: String,
         //     default: "rgba(255,255,255,1)"
         // }

     }
 }